import '@styles/pages/seller-onboarding.scss';
import { showSubmitLoader } from '@tools/submit-loader';
import { initVuePhoneInput } from '@organisms/twig-phone-input';
import { addCaptchaToForm } from '@tools/recaptcha-helper';
import { resendInitPasswordEmail } from '@tools/resend-init-password-email';
import { eventBus } from '@tools/event-bus';
import { URL_OFFER_CREATE, URL_SELLER_ONBOARDING_RESEND_EMAIL } from '@tools/routes/routes';
import { TwigFormValidator } from '@tools/twig-form/validator';

const formSelector = 'seller-onboarding-form';

function initFormValidation() {
  const phoneInputApp = initVuePhoneInput('vue-phone-input');
  const validator = new TwigFormValidator({
    formSelector: `#${formSelector}`,
    rules: {
      'seller_onboarding_form[organization][name]': 'required',
      'seller_onboarding_form[fullName]': [ 'required', 'noNumbers' ],
      'seller_onboarding_form[email]': [ 'required', 'email' ],
      'seller_onboarding_form[phoneNumber]': 'phone',
    },
    messages: {
      'seller_onboarding_form[fullName]': [ 'required', 'noNumbers' ],
      'seller_onboarding_form[email]': [ 'required', 'email' ],
    },
    onFailure: (event, messages) => {
      const phoneError = messages['seller_onboarding_form[phoneNumber]'];
      phoneInputApp.error = phoneError ?? null;
      event.stopImmediatePropagation();
    },
    onSuccess: (event) => {
      phoneInputApp.error = null;
      showSubmitLoader(event.target.querySelector('button[type=submit]'));
    },
  });
  validator.init();
}

function attachEventListenerLoginLinks() {
  document
    .querySelectorAll('#seller-onboarding .seller-onboarding-login')
    .forEach((element) => {
      element.addEventListener('click', () => {
        eventBus.dispatchEvent(new CustomEvent('show-login-modal', {
          detail: {
            email: null,
            redirectUrl: URL_OFFER_CREATE,
          },
        }));
      });
    });
}

initFormValidation();
attachEventListenerLoginLinks();
resendInitPasswordEmail('#seller-onboarding .seller-onboarding-email-resend', URL_SELLER_ONBOARDING_RESEND_EMAIL);

window.addEventListener('load', () => {
  addCaptchaToForm(formSelector, 'seller_onboarding_form');
});
